import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import Boundary from "./components/Boundary";
import "./styles/theme.css";
import { initTheme } from "./lib/theme";

initTheme();

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Boundary><App /></Boundary>
  </React.StrictMode>
);
